// extracted by mini-css-extract-plugin
export default {"loader_container":"Common_loader_container__didS+","loader":"Common_loader__Ix4CL","around":"Common_around__g1-l+","darken_loader":"Common_darken_loader__mUAVf"};